import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { bankAccountsApi } from 'src/Services/API';
import { BankAccountDto, CreateBankAccountDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useCreateBankAccount = (
  options?: UseMutationOptions<BankAccountDto, unknown, CreateBankAccountDto>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<BankAccountDto, unknown, CreateBankAccountDto>(
    ['create-bank-account', assetId],
    async bankAccountData => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await bankAccountsApi.bankAccountsControllerCreate(assetId, bankAccountData);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('BankAccount', 'create');
        queryClient.invalidateQueries({ queryKey: ['fetch-bank-accounts', assetId] });
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    }
  );
};
